export default __webpack_public_path__ + "static/image-980f21a2ca7fd3f7c9c16b144cd8796f.jpg";